<!-- pagination -->
<div class="pagination-container ">
  <div class="row list-footer-sty" *ngIf="totalItemCount > 0">
    <div class="col-md-4 " style="    padding: 0px;">
      <ng-container *ngIf="showChangePageSize">
        <span class="show-pagination-control">Show
          <span>
            <mat-form-field class="page-select-pagination" floatLabel="never" appearance="outline">
              <input matInput type="number" [(ngModel)]="pageSize"
                (ngModelChange)="onPageSizeModelChange($event)" />
            </mat-form-field>
          </span>
        </span>
        <span class="paginatn-sepertn"></span>
      </ng-container>
      <span class="page-style" [innerHTML]="paginationText"></span>
    </div>
    <div class="col-md-6" style="    padding: 0px;">
      <ul *ngIf="pages && pages.length" class="arrowHead pagination pagination-lg m-t-5 m-b-10">
        <li class="list-head-1">
          <div *ngIf="pageIndex === 0; then disablefirst else enablefirst">
          </div>
          <ng-template #disablefirst>
            <a class="anchor-opacity">
              <img src="assets/img/arrowfirst.svg" class="arrow-height">
            </a>
          </ng-template>
          <ng-template #enablefirst>
            <a class="enable-anchor" (click)="setPagination('first',0)">
              <img src="assets/img/arrowfirst.svg" class="arrow-height">
            </a>
          </ng-template>
        </li>
        <li class="list-head-2">
          <div *ngIf="pageIndex === 0; then disableprev else enableprev">
          </div>
          <ng-template #disableprev>
            <a class="anchor-opacity">
              <img src="assets/img/arrowprev.svg" class="arrow-prev-height">
            </a>
          </ng-template>
          <ng-template #enableprev>
            <a class="enable-anchor" (click)="setPagination('prev',0)">
              <img src="assets/img/arrowprev.svg" class="arrow-prev-height">
            </a>
          </ng-template>
        </li>
        <li *ngFor="let page of pages" [ngClass]="{active:pageIndex === (page-1)}">
          <a class="enable-anchor" (click)="setPagination('current',page)">{{page}}</a>
        </li>
        <li class="list-head-3">
          <div *ngIf="pageIndex === (pageCount-1); then disablelast else enablelast">
          </div>
          <ng-template #disablelast>
            <a class="anchor-opacity">
              <img src="assets/img/arrowprev.svg" class="arrow-last">
            </a>
          </ng-template>
          <ng-template #enablelast>
            <a class="enable-anchor" (click)="setPagination('next',0)">
              <img src="assets/img/arrowprev.svg" class="arrow-last">
            </a>
          </ng-template>
        </li>
        <li class="list-head-4">
          <div *ngIf="pageIndex === (pageCount-1); then disableclick else enableclick">
          </div>
          <ng-template #disableclick>
            <a class="anchor-opacity">
              <img src="assets/img/arrowfirst.svg" class="arrow-click">
            </a>
          </ng-template>
          <ng-template #enableclick>
            <a class="enable-anchor" (click)="setPagination('last',0)">
              <img src="assets/img/arrowfirst.svg" class="arrow-click">
            </a>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>
</div>
<!-- pagination -->